import React, { useContext } from 'react';
import { Row, Col, Placeholder } from '@thd-olt-component-react/core-ui';
import { EXP_ROUTES } from '../../../utils/constants';
import { StatusIndicator } from './StatusIndicator';
import GoBackNavLink from '../../common/GoBackNavLink';
import OverflowTooltip from '../../common/OverflowTooltip/OverflowTooltip';
import { JobPostingContext } from '../../../contexts/JobPostingContext';

export const JobPostingPageHeader = () => {
  const backToObj = {
    backTo: 'Job Postings',
    backToUrl: EXP_ROUTES.JOB_POSTINGS
  };

  const { activeJobPosting, isJobPostingFetching } = useContext(JobPostingContext);

  if (isJobPostingFetching) {
    return (
      <div
        data-testid="job-posting-header-loader"
        style={{
          marginTop: '44px',
          marginBottom: '30px'
        }}
      >
        <Placeholder type="rect" height="50px" width="350px" />
      </div>
    );
  }

  return (
    <Row>
      <Col xs={12}>
        <div className="ptp-job-posting__header">
          <GoBackNavLink backToStr={backToObj.backTo} fallbackUrl={backToObj.backToUrl} />
          <div className="ptp-job-posting__title-status-container">
            <OverflowTooltip className="ptp-job-posting__title" byHeight>
              <p>{activeJobPosting.title}</p>
            </OverflowTooltip>
            <div className="ptp-job-posting__status-container">
              <StatusIndicator status={activeJobPosting.status} />
            </div>
          </div>
          {activeJobPosting.status === 'DRAFT' && (
            <div className="ptp-job-posting__draft-watermark">
              <p>DRAFT</p>
            </div>
          )}
        </div>
      </Col>
    </Row>
  );
};
